import PropTypes from 'prop-types';

import { DESIGN_ENUMS, SIZE_LARGE, SIZE_STANDARD } from '../../ChannelList/constants/carousels';
import { ENUMS_COMMENTS } from '../../PlayerOverview/constants/comments';

import { TYPE_ENUMS } from './channel';
import {
  CUSTOM_TAG_VALUE,
  SYSTEM_TAG_BRANDS,
  SYSTEM_TAG_CC,
  SYSTEM_TAG_PEOPLE,
  SYSTEM_TAG_TEXT,
  TYPE_DESCRIBE_PLOT,
  TYPE_DESCRIBE_TITLE,
} from './label';
import {
  ACCESS_PRIVATE,
  ACCESS_PUBLIC,
  ACCESS_SITE,
  USER_ROLE_OWNER,
  USER_ROLE_VIEWER,
  VIDEO_ASPECT_RATIO_1X1,
  VIDEO_ASPECT_RATIO_4X3,
  VIDEO_ASPECT_RATIO_9X16,
  VIDEO_ASPECT_RATIO_16X9,
} from './video';
import { ALL_SOCIAL_ENGAGEMENT_TYPES } from './videoEngagement';

export const videoPerformanceDataParametersPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    type: PropTypes.oneOf(ALL_SOCIAL_ENGAGEMENT_TYPES).isRequired,
    value: PropTypes.number.isRequired,
  }),
);

export const videoPerformanceDataPropTypes = PropTypes.shape({
  time: PropTypes.number.isRequired,
  parameters: videoPerformanceDataParametersPropTypes.isRequired,
});

export const filesPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    file: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }),
);

export const videoPropTypes = PropTypes.shape({
  title: PropTypes.string.isRequired,
  mediaid: PropTypes.string.isRequired,
  videoId: PropTypes.string.isRequired,
  plot: PropTypes.string.isRequired,
  created: PropTypes.number.isRequired,
  duration: PropTypes.number.isRequired,
  images: filesPropTypes.isRequired,
  files: filesPropTypes.isRequired,
  ccFiles: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.string.isRequired,
      lang: PropTypes.string.isRequired,
      langName: PropTypes.string.isRequired,
      sizeInBytes: PropTypes.number.isRequired,
    }),
  ),
  previewUrl: PropTypes.string,
  ccUrl: PropTypes.string.isRequired,
  trending: PropTypes.number.isRequired,
  defaultOrder: PropTypes.number.isRequired,
  performanceData: videoPerformanceDataPropTypes.isRequired,
  highlights: PropTypes.bool,
  slides: PropTypes.bool,
  describe: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.oneOf([SYSTEM_TAG_CC, SYSTEM_TAG_TEXT, SYSTEM_TAG_BRANDS, SYSTEM_TAG_PEOPLE, CUSTOM_TAG_VALUE])
        .isRequired,
    }).isRequired,
  ).isRequired,
  highlight: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf([TYPE_DESCRIBE_TITLE, TYPE_DESCRIBE_PLOT]).isRequired,
      fragments: PropTypes.arrayOf(PropTypes.string).isRequired,
      stopWords: PropTypes.arrayOf(PropTypes.string).isRequired,
    }).isRequired,
  ).isRequired,
  access: PropTypes.shape({
    users: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        role: PropTypes.oneOf([USER_ROLE_OWNER, USER_ROLE_VIEWER]),
      }),
    ),
    sites: PropTypes.arrayOf(PropTypes.number),
    level: PropTypes.oneOf([ACCESS_PUBLIC, ACCESS_SITE, ACCESS_PRIVATE]),
  }),
  aspectRatio: PropTypes.oneOf([
    VIDEO_ASPECT_RATIO_16X9,
    VIDEO_ASPECT_RATIO_9X16,
    VIDEO_ASPECT_RATIO_4X3,
    VIDEO_ASPECT_RATIO_1X1,
  ]),
});

export const channelPropTypes = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.oneOf(TYPE_ENUMS),
  playlistLoaded: PropTypes.bool.isRequired,
  playlist: PropTypes.arrayOf(videoPropTypes).isRequired,
  size: PropTypes.oneOf([SIZE_STANDARD, SIZE_LARGE]).isRequired,
  description: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  design: PropTypes.oneOf(DESIGN_ENUMS).isRequired,

  titleColor: PropTypes.string,
  descColor: PropTypes.string,
  vidTitleColor: PropTypes.string,
  vidInfoColor: PropTypes.string,

  cTitleColor: PropTypes.string,
  cVidTitleColor: PropTypes.string,
  cVidInfoColor: PropTypes.string,
});

export const commentPropTypes = PropTypes.shape({
  activeChildCount: PropTypes.number.isRequired,
  deletedChildCount: PropTypes.number.isRequired,
  time: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  parentId: PropTypes.string, // nullable
  status: PropTypes.oneOf(ENUMS_COMMENTS).isRequired,
  created: PropTypes.number.isRequired,
  html: PropTypes.string.isRequired,
  author: PropTypes.shape({
    id: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
  }),
});
